<template>
    <div class="site-logo">
        <router-link to="/">
            <img :src="appLogo" alt="site logo"  height="65">
        </router-link>
    </div>
</template>

<script>
import AppConfig from "@/config/AppConfig";
import { mapGetters } from "vuex";

export default {
   computed: {
      
   },
   data() {
      return {
          appLogo: AppConfig.appLogo,
      }
   }
}
</script>
